/**
 * A passport typed in a search (owner, 28 Sep 2026: a tourist cannot be found by passport). Pure, shared by the
 * contacts store (findCustomers) and Ask Yelo; the engine's customer lookup has the same rule (api.main._identity_typed).
 *
 * A passport = letters AND digits, 6 to 12 of them, at most 3 letters and at least 6 digits (spaces / dashes ignored):
 * N1234567, AB1234567, P1234567A, C01X00T47. Never one of these, which stay what they were:
 *   - an Ejar contract number, even cut short: I2609000D01443839, B2609000D04…, C2609000D02…, C2511ARE759740
 *   - an old all-digit contract (1943174), a phone or an Emirates ID: no letter
 *   - a plate (AB 12345): at most 5 digits
 *   - a name: no digit
 * Returns the passport as the identities are compared (letters and digits only, upper case), else ''.
 */
const CONTRACT_START = /^[A-Z]{1,2}\d{4,8}(?:D\d|ARE)/;

export function passportKey(text) {
    const s = String(text ?? '').trim();
    if (!/^[A-Za-z0-9][A-Za-z0-9 -]*$/.test(s)) return '';
    const key = s.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    const letters = (key.match(/[A-Z]/g) || []).length;
    const digits = key.length - letters;
    if (key.length < 6 || key.length > 12 || letters < 1 || letters > 3 || digits < 6) return '';
    return CONTRACT_START.test(key) ? '' : key;
}

export default passportKey;
